import Layout from 'shared/layouts/containers/Main'
import React from 'react'
import { Row } from 'react-bootstrap'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import { roles } from 'consts'
import hasAnyRole from 'shared/utils/hasAnyRole'
import Carriers from 'pages/Carriers'
import { Badge, Card, CardBody, CardFooter, CardHeader, Col } from 'reactstrap'
import * as Icon from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'

const Settings: React.FunctionComponent = () => {
  const navigate = useNavigate()

  return hasAnyRole([roles.superAdmin]) ? (
    <Carriers />
  ) : (
    <Layout footerContent={<Footer />} brandContent={getBrandContent()} showOverlay={false}>
      <Row className='my-md-3'>
        <Col md='4'>
          <Card
            className='h-100 align-middle mt-sm-3 mt-md-0'
            role='button'
            onClick={() => navigate('/settings')}
          >
            <CardHeader className='bg-primary text-white fs-5 align-middle'>
              <div className='ps-3 py-2'>Settings</div>
            </CardHeader>
            <CardBody className='fs-4 text-center'>
              <Icon.Gear />
              &nbsp;Manage Settings
            </CardBody>
            <CardFooter className='text-end'>
              <Badge className='bg-primary'> Detail</Badge>
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </Layout>
  )
}

export default Settings
